<template>
  <header class="l-header">
    <div class="l-header__buttons">
      <common-button
        class="u-mR16"
        v-if="!isLoggedIn"
        :title="'会員登録'"
        :small="true"
        :attr=[]
        :callback="navigateToRegister"
        :no_width="true"
        :bg_red="true"
        :display="'inline-flex'"
        :font_size="'12px'" />
      <common-button
        class="u-mR16"
        v-else
        :title="'マイページ'"
        :type="'link'"
        :link_url="'/mypage'"
        :small="true"
        :no_width="true"
        :bg_red="true"
        :display="'inline-flex'"
        :font_size="'12px'" />
      <common-button
        v-if="!isLoggedIn"
        :title="'ログイン'"
        :border_gray="true"
        :callback="login"
        :attr=[]
        :small="true"
        :no_width="true"
        :display="'inline-flex'"
        :font_size="'12px'" />
      <common-button
        v-else
        :callback="logOut"
        :attr=[]
        :title="'ログアウト'"
        :border_gray="true"
        :small="true"
        :no_width="true"
        :display="'inline-flex'"
        :font_size="'12px'" />
    </div>
    <a href="/">
      <img class="l-header__logo" src="@/assets/images/logo.png" alt="お得な不動産 KEIAIミツカル（ケイアイ ミツカル）">
    </a>

    <div class="l-header__menus">
      <a class="c-actionBox u-mR10" href="/bookmark/">
        <img class="c-actionBox__icon" src="@/assets/images/icon-favourite.png" alt="">
        <p class="c-actionBox__text">お気に入り</p>
        <p class="c-actionBox__count">{{storedFavorite.found}}件</p>
      </a>

      <a class="c-actionBox c-actionBox--history u-mR10" v-if="!isMobile" href="/history/view/">
        <img class="c-actionBox__icon" src="@/assets/images/icon-history.png" alt="">
        <p class="c-actionBox__text" style="font-size: 11px;">最近見た物件</p>
        <p class="c-actionBox__count">{{storedViewHistory.found}}件</p>
      </a>

      <a class="c-actionBox" href="/history/search/">
        <img class="c-actionBox__icon" src="@/assets/images/icon-search.png" alt="">
        <p class="c-actionBox__text">検索履歴</p>
        <p class="c-actionBox__count">{{storedSearchHistory.found}}件</p>
      </a>

      <span class="c-menu" @click="isMenuDisplay = !isMenuDisplay">
        <img class="c-menu__img" src="@/assets/images/menu.png" alt="">
      </span>
    </div>

    <div class="c-drawer" v-if="isMobile && isMenuDisplay">
      <div class="c-drawer__inner">
        <div class="p-x" @click="isMenuDisplay=!isMenuDisplay"><img src="@/assets/batsu.png" height=32p width=32 ></div>
        <ul class="c-drawer__list">
          <li v-if="!isLoggedIn" class="c-drawer__item">
            <a class="c-drawer__link" @click="login">ログイン</a>
          </li>
          <li v-else class="c-drawer__item">
            <a class="c-drawer__link" @click="logOut">ログアウト</a>
          </li>
          <li v-if="!isLoggedIn" class="c-drawer__item">
            <a class="c-drawer__link" @click="navigateToRegister">会員登録</a>
          </li>
          <li v-else class="c-drawer__item">
            <a class="c-drawer__link" href="/mypage/">マイページ</a>
          </li>
          <li class="c-drawer__item">
            <a class="c-drawer__link c-drawer__link--flex" href="/bookmark/">
              お気に入り
              <span class="c-drawer__count">{{storedFavorite.found}}件</span>
            </a>
          </li>

          <li class="c-drawer__item">
            <a class="c-drawer__link c-drawer__link--flex" href="/history/view/">
              最近見た物件
              <span class="c-drawer__count">{{storedViewHistory.found}}件</span>
            </a>
          </li>
          <li class="c-drawer__item">
            <a class="c-drawer__link c-drawer__link--flex" href="/history/search/">
              検索履歴
              <span class="c-drawer__count">{{storedSearchHistory.found}}件</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { signOut, signIn, saveRegisterRedirect } from '@/utils/auth';

import isMobile from '@/plugins/isMobile';
import CommonButton from '@/components/parts/button/CommonButton';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';


export default {
  name: 'CommonHeader',
  mixins: [isMobile, BehaviorLogMixin],
  components: {
    CommonButton,
  },
  data() {
    return {
      isMenuDisplay: false,
      fav: [],
      view: [],
      search: [],
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.userReady': async function () {
      await this.refreshUserBehaviorData();
    },
  },
  methods: {
    async logOut() {
      await signOut();
    },
    async refreshUserBehaviorData() {
      // お気に入り
      // this.fav = JSON.parse(localStorage.getItem('fav'));
      // if (this.fav === null) this.fav = [];
      // this.$store.commit('setFavorite', this.fav);
      this.fav = await this.retrieveWishList();

      // 閲覧履歴
      // this.view = JSON.parse(localStorage.getItem('view'));
      // if (this.view === null) this.view = [];

      this.view = await this.retrieveSiteAccessLogs();

      // 検索履歴
      // this.search = JSON.parse(localStorage.getItem('search'));
      // if (this.search === null) this.search = [];
      this.search = await this.retrieveSiteQueryLogs();
    },
    navigateToRegister() {
      saveRegisterRedirect();
      this.$router.push('/member/signup');
      this.isMenuDisplay = false;
    },
    login() {
      signIn();
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
    storedFavorite() {
      return this.$store.getters['getFavorite'];
    },
    storedViewHistory() {
      return this.$store.getters['getViewHistory'];
    },
    storedSearchHistory() {
      return this.$store.getters['getSearchHistory'];
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

.l-header {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 40px;
  border-bottom: 1px solid #ccc;

  &__buttons {
    display: flex;
    align-items: center;
    width: 260px;
  }
  &__logo {
    width: 165px;
    height: 40px;
    object-fit: contain;
  }
  &__menus {
    width: 260px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.c-actionBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 72px;
  padding: 6px 0;
  border: 1px solid #ccc;
  border-radius: 10px;

  &__icon {
    width: 24px;
    height: 23px;
    margin-bottom: 8px;
  }
  &__text, &__count {
    color: #666;
    font-size: 12px;
  }
  &__text {
    margin-bottom: 4px;
    width: 100%;
    text-align: center;
  }
}

.c-menu, .c-drawer {
  display: none;
}

.u-mR16 {
  margin-right: 16px;
}
.u-mR20 {
  margin-right: 20px;
}

.u-mR10 {
  margin-right: 10px;
}

@media screen and (max-width: 767px) {
  .l-header {
    padding: 10px 15px;

    &__buttons {
      display: none;
    }
    &__logo {
      width: 122px;
    }
  }

  .c-actionBox {
    width: 64px;
    // height: 56px;

    &--history {
      display: none;
    }
    &__icon {
      width: 16px;
      height: 15px;
    }
    &__text {
      font-size: 10px;
      margin: 1px 4px;
      width: 100%;
      text-align: center;
    }
  }

  .c-menu {
    display: block;
    margin-left: 10px;
  }

  .c-drawer {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.9);
    z-index: 210;

    &__inner {
      position: absolute;
      top: 0;
      right: 0;
      width: 75%;
      height: 100%;
      background: #fff;
    }
    &__title {
      padding: 13px 20px 17px;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      background: #E83532;
    }
    &__item {
      border-bottom: 1px solid #ccc;
    }
    &__link {
      display: flex;
      width: 100%;
      padding: 13px 20px;
      color: #666;
      min-height: 50px;
      font-size: 14px;
      align-items: center;

      &--flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    &__count {
      padding: 7px 10px;
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
      background: #666;
    }
  }
}

.p-x {
  width: 32px;
  height: 32px;
  position: absolute;
  left: -40px;
  top: 8px;
}

.c-menu__img {
  width: 40px;
  height: 27px;
}

@media (max-width: 639px) {
  .l-header {
    &__menus {
      min-width: 100px;
    }
  }
}

</style>
